import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import { sidebarwith } from './Const';
//  React.MouseEvent<HTMLButtonElement> ts input type

export default function TextfieldNumber(props) {
    const {label,unit,id,...otherProps} = props

  return (
    <div style={{padding:'1rem'}}>
        <FormControl size = 'small' 
        sx = {{width:sidebarwith}}
        >
        <InputLabel htmlFor="outlined-adornment-amount">{label}</InputLabel>
        <OutlinedInput
        type="number"
        id={id}
        endAdornment={<InputAdornment position="start">{unit}</InputAdornment>}
        label={label}
        />
    </FormControl>
  </div>
  );
}
